import { defineComponent as v, inject as N, computed as r, createBlock as h, openBlock as a, unref as l, normalizeStyle as z, normalizeClass as F, createSlots as M, withCtx as t, renderSlot as p, createElementVNode as n, createVNode as c, createElementBlock as y, createCommentVNode as T, toDisplayString as m, resolveDynamicComponent as B, createTextVNode as O } from "vue";
import { fallbackCommonSize as w } from "./highrise68.mjs";
import { JSONtoNaiveVars as S } from "./highrise343.mjs";
import L from "./highrise134.mjs";
import "./highrise59.mjs";
import P from "./highrise446.mjs";
import { feedbackTextAndFontSize as j, getFormItemCommonStyles as x } from "./highrise447.mjs";
import { createFormInputSizes as E } from "./highrise448.mjs";
import { COMPONENT_NAME as I } from "./highrise178.mjs";
import V from "./highrise449.mjs";
import $ from "./highrise84.mjs";
const R = { class: "hr-form-custom-label" }, A = {
  key: 0,
  class: "hr-form-custom-label__asterisk"
}, D = { key: 0 }, H = v({
  name: I.FORM_ITEM
}), oe = /* @__PURE__ */ v({
  ...H,
  props: {
    label: {
      type: String
    },
    path: {
      type: String
    },
    showLabel: {
      type: Boolean,
      default: void 0
    },
    showFeedback: {
      type: Boolean,
      default: void 0
    },
    rule: {
      type: Object,
      default: void 0
    },
    tooltip: {
      type: Object,
      default: null
    },
    required: Boolean,
    feedback: String,
    validationStatus: {
      type: String
    },
    showFeedbackTooltip: {
      type: Boolean,
      default: !0
    },
    feedbackLineClamp: {
      type: Number,
      default: 1
    },
    feedbackTooltipProps: {
      type: Object
    },
    showRequireMark: {
      type: Boolean,
      default: void 0
    },
    requireMarkPlacement: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const s = e, i = N("hr-form", "2xs"), g = r(() => ({
      ...S(x()),
      ...S(E(w(i), s.feedbackLineClamp))
    })), C = r(() => {
      const { feedbackTooltipProps: o } = s;
      return typeof o == "object" ? o : {};
    }), q = r(() => ({
      [`hr-form-item--${w(i)}-size`]: !0,
      "hr-form-item__container": !0
    }));
    return (o, J) => {
      var d;
      return a(), h(l(V), {
        rule: e.rule,
        label: e.label,
        path: e.path,
        "show-label": ((d = e.label) == null ? void 0 : d.length) > 0 && e.showLabel,
        "show-feedback": e.showFeedback,
        class: F(["hr-form-item" + (e.tooltip ? " hr-form-has-custom-label" : ""), q.value]),
        required: e.required,
        style: z(g.value),
        feedback: e.feedback,
        "validation-status": e.validationStatus,
        "show-require-mark": e.showRequireMark,
        "require-mark-placement": e.requireMarkPlacement
      }, M({
        default: t(() => [
          p(o.$slots, "default")
        ]),
        _: 2
      }, [
        e.tooltip ? {
          name: "label",
          fn: t(() => {
            var f, u, b, k;
            return [
              n("div", R, [
                n("span", null, [
                  n("span", null, m(e.label), 1),
                  e.required && e.showRequireMark ? (a(), y("span", A, " *")) : T("", !0)
                ]),
                c(P, {
                  placement: (f = e.tooltip) == null ? void 0 : f.placement,
                  trigger: (u = e.tooltip) == null ? void 0 : u.trigger,
                  icon: (b = e.tooltip) == null ? void 0 : b.icon,
                  "icon-class": (k = e.tooltip) == null ? void 0 : k.iconClass
                }, {
                  default: t(() => [
                    typeof e.tooltip.tooltipContent == "string" ? (a(), y("span", D, m(e.tooltip.tooltipContent), 1)) : (a(), h(B(e.tooltip.tooltipContent), { key: 1 }))
                  ]),
                  _: 1
                }, 8, ["placement", "trigger", "icon", "icon-class"])
              ])
            ];
          }),
          key: "0"
        } : void 0,
        e.feedback ? {
          name: "feedback",
          fn: t(() => [
            c(L, {
              "line-clamp": e.feedbackLineClamp,
              "tooltip-props": C.value,
              "show-tooltip": e.showFeedbackTooltip
            }, {
              default: t(() => [
                c(l($), {
                  size: l(j)[l(i)]
                }, {
                  default: t(() => [
                    O(m(e.feedback), 1)
                  ]),
                  _: 1
                }, 8, ["size"])
              ]),
              _: 1
            }, 8, ["line-clamp", "tooltip-props", "show-tooltip"])
          ]),
          key: "1"
        } : {
          name: "feedback",
          fn: t(() => [
            p(o.$slots, "feedback")
          ]),
          key: "2"
        }
      ]), 1032, ["rule", "label", "path", "show-label", "show-feedback", "class", "required", "style", "feedback", "validation-status", "show-require-mark", "require-mark-placement"]);
    };
  }
});
export {
  oe as default
};
